import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourNotificacionesEnvios: TourDefinicion = {
  codigo: 'notificaciones-envios',
  titulo: 'Envíos de correo',
  descripcion: 'Bitácora de correos enviados, pendientes y fallidos.',
  ruta: '/admin/notificaciones/envios',
  permisoMenu: Permisos.ENVIOS_MENU,
  pasos: [
    {
      id: 'notificaciones-envios:header',
      selector: '[data-testid="notificaciones-envios.header"]',
      titulo: 'Envíos de correo',
      descripcion:
        'Monitorea los correos que el sistema intentó enviar. Útil para diagnosticar fallas de SMTP o destinatarios inválidos.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'notificaciones-envios:tabla',
      selector: '[data-testid="notificaciones-envios.tabla"]',
      titulo: 'Listado y reintento',
      descripcion:
        'Abre el detalle de un envío para ver el contenido y las razones de falla. Si fue rechazado, puedes reintentar el envío.',
      side: 'top',
      align: 'center',
    },
  ],
};
